import SectionHeader from "../components/SectionHeader";
import { motion } from "framer-motion";
import { Award, Heart, Target, Users } from "lucide-react";
import { Link } from "react-router-dom";
import { SITE, VALUES } from "../data/site";

export default function About() {
  return (
    <>
      <section className="container-st pt-16 pb-20">
        <SectionHeader
          eyebrow={`About ${SITE.short}`}
          title="An indigenous dynamic IT solutions partner."
          subtitle={`${SITE.company} (${SITE.rc}) is committed to building the best and simplified Web, Mobile & Social applications at an affordable cost — helping clients run their businesses easily and effectively through scalable architectures, cloud deployment, SEO/SEM and application maintenance.`}
        />
        <div className="grid lg:grid-cols-2 gap-10 mt-14 items-center">
          <motion.img
            initial={{ opacity: 0, x: -30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
            src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?auto=format&fit=crop&w=1200&q=80"
            alt="team"
            className="rounded-3xl shadow-sm"
          />
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6 }}
          >
            <h3 className="text-3xl font-semibold text-slate-900">Mission</h3>
            <p className="mt-3 text-slate-600 leading-relaxed">
              To provide companies with a personal and pro-active approach to maintaining and
              improving their IT infrastructure and software requirements.
            </p>
            <h3 className="mt-8 text-3xl font-semibold text-slate-900">Vision</h3>
            <p className="mt-3 text-slate-600 leading-relaxed">
              Our vision serves as the framework for our roadmap by describing what we need to do
              to continue to be an innovative leader — setting the pace.
            </p>
            <div className="grid grid-cols-2 gap-4 mt-8">
              {[
                { Icon: Award, t: "240+", s: "Projects shipped" },
                { Icon: Users, t: "60+", s: "Specialists" },
                { Icon: Heart, t: "98%", s: "Client retention" },
                { Icon: Target, t: "3", s: "Offices: NG + UK" },
              ].map(({ Icon, t, s }) => (
                <div key={s} className="rounded-2xl border border-slate-100 p-5">
                  <Icon className="w-5 h-5 text-blue-600" />
                  <div className="mt-2 text-2xl font-bold text-slate-900">{t}</div>
                  <div className="text-xs uppercase tracking-widest text-slate-500">{s}</div>
                </div>
              ))}
            </div>
            <Link
              to="/profile"
              data-testid="about-cta-profile"
              className="mt-8 inline-flex items-center gap-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-full"
            >
              See full company profile →
            </Link>
          </motion.div>
        </div>
      </section>

      <section className="bg-slate-50/60 section-pad">
        <div className="container-st">
          <SectionHeader eyebrow="Our values" title="Principles that guide every project." center />
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mt-12">
            {VALUES.map((v, i) => (
              <motion.div
                key={v.t}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="rounded-3xl bg-white p-8 border border-slate-100"
              >
                <h3 className="text-xl font-semibold text-slate-900">{v.t}</h3>
                <p className="mt-3 text-slate-600">{v.d}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
